// Weekly audio analysis is short-lived: check promptly once, then back off
// when still processing or transiently unavailable. No SSE fallback involved.
export const AUDIO_ANALYSIS_FIRST_POLL_MS = 3000;
export const AUDIO_ANALYSIS_MAX_POLL_MS = 30000;

export function nextAudioAnalysisPollDelay(attemptNumber) {
  const n = Number(attemptNumber);
  if (!Number.isFinite(n) || n <= 0) return AUDIO_ANALYSIS_FIRST_POLL_MS;
  return Math.min(AUDIO_ANALYSIS_MAX_POLL_MS, AUDIO_ANALYSIS_FIRST_POLL_MS * 2 ** Math.min(6, Math.floor(n)));
}
